import { JsonObject } from "../interface/json";

export const userService = {
  logout(info: JsonObject) {
    const path = "member/member/associate/Logout";
    return $sk.$skxhr(path, info);
  },
  contact(info: JsonObject) {
    const path = "api/member/contacts/info/get";
    return $sk.$skxhr(path, info);
  },
};
